import quoteReducer from "./quote/reducer";
import accountReducer from "./account/reducer";
import kycReducer from "./kyc/reducer";

export default {
  quoteReducer,
  accountReducer,
  kycReducer
};
